import i18n from 'i18next';

export default (eligibleMembers, membersCount) => {
  if (eligibleMembers) {
    return i18n.t('eligible-members-count-total', { countTotal: eligibleMembers });
  }
  return i18n.t('member-count', { count: membersCount ?? 0 });
};
